// BOOTSTRAP
import 'bootstrap'; // importing bootstrap.js
// import bs_reboot from 'bootstrap/scss/bootstrap-reboot.scss';
// import bs_grid from 'bootstrap/scss/bootstrap-grid.scss';
import bs_style from 'bootstrap/scss/bootstrap.scss';

// FONT-AWESOME
import fontawesome from '@fortawesome/fontawesome';
import fasolid from '@fortawesome/fontawesome-free-solid';
import faregular from '@fortawesome/fontawesome-free-regular';
import fabrands from '@fortawesome/fontawesome-free-brands';

// PROMISES
import "native-promise-only";

// OBJECTFITIMAGES
import objectFitImages from 'object-fit-images';
objectFitImages();

// TOASTR
import toastr_style from 'toastr/toastr.scss';

import 'select2/dist/css/select2.min.css';



// WEBPACK FOOTER //
// ./vendor/index.js